const FORCES = [
  { key: "entrants", title: "Threat of New Entrants" },
  { key: "buyers", title: "Bargaining Power of Buyers" },
  { key: "suppliers", title: "Bargaining Power of Suppliers" },
  { key: "substitutes", title: "Threat of Substitutes" },
  { key: "rivalry", title: "Industry Rivalry" },
];

export const RATINGS = ["Low", "Medium", "High"];
const chip = { Low: "bg-emerald-50 text-emerald-700 border-emerald-200", Medium: "bg-amber-50 text-amber-700 border-amber-200", High: "bg-red-50 text-red-700 border-red-200", "": "bg-slate-100 text-slate-400 border-slate-200" };

export default function FiveForcesBlueprint({ doc }) {
  const p = doc.payload || {};
  return (
    <div className="space-y-3" data-testid="five-forces-blueprint">
      {FORCES.map((f) => {
        const v = p[f.key] || {};
        return (
          <div key={f.key} data-testid={`force-${f.key}`} className="bg-white border border-slate-200 rounded-sm overflow-hidden">
            <div className="px-5 py-3 border-b border-slate-100 flex items-center justify-between bg-slate-50">
              <h3 className="text-sm font-semibold tracking-wide uppercase text-slate-700">{f.title}</h3>
              <span className={`px-2.5 py-1 rounded-sm text-xs font-bold uppercase border ${chip[v.rating || ""]}`}>{v.rating || "—"}</span>
            </div>
            <div className="p-5"><p className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed">{v.notes || <span className="text-slate-300">—</span>}</p></div>
          </div>
        );
      })}
    </div>
  );
}
